module.exports = __webpack_public_path__ + "img/67ne.8de138bf.svg";